import { extendTailwindMerge } from 'tailwind-merge';
import clsx from 'clsx';

/**
 * Custom configuration for Tailwind Merge.
 */
const twMergeConfig = {};

/**
 * Extend Tailwind Merge with custom configuration
 */
const twMerge = extendTailwindMerge({ extend: twMergeConfig });

/**
 * Combines class names using `clsx` and merges Tailwind classes with `twMerge`.
 *
 * @param {...import('clsx').ClassValue} inputs - Class names, arrays, or objects to apply.
 * @returns {string} The merged class name string.
 */
export default function classNames(...inputs) {
    return twMerge(clsx(...inputs));
}
